// extracted by mini-css-extract-plugin
export default {"statDisk":"Pie_statDisk__jB9vT"};